import { Plus } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function LandingFaq() {
    const { t } = useTranslation();
    return (
        <section id="faq" className="landing-section landing-faq" aria-labelledby="faq-title">
            <div className="landing-container landing-faq-grid">
                <div className="landing-section-heading">
                    <p className="landing-eyebrow">{t('faq.badge')}</p>
                    <h2 id="faq-title">{t('faq.title')}</h2>
                    <p>{t('faq.subtitle')}</p>
                </div>
                <div className="landing-faq-list">
                    {['phone', 'ai', 'missed', 'free', 'languages', 'care'].map(key => <details key={key} name="landing-faq">
                        <summary>{t(`faq.items.${key}.question`)}<Plus size={19} aria-hidden="true" /></summary>
                        <p>{t(`faq.items.${key}.answer`)}</p>
                    </details>)}
                </div>
            </div>
        </section>
    );
}
